import React, { Component } from "react";
import UpdateCareerObjective from "./updateCareerObjective";
import axios from "axios";
// routes
import { API_CANDIDATE } from "../../../../utils/config";
import {DATE_FORMAT} from '../../../../utils/config'
import DateFns from "date-fns";


/**
 * Career objective Component for displaying the candidate details.
 */
class CareerObjective extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addBtn: false,
      updateBtn: false,
      data: [],
      validid: false,
      isOpen: false,
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this);
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.getData = this.getData.bind(this);
  }

  // openAddForm

  openAddForm() {
    this.setState({
      addBtn: true,
    });
  }

  // closing Add form(toggling)
  closeAddForm() {
    this.setState({
      addBtn: false,
    });
  }

  // openUpdateForm

  openUpdateForm() {
    this.setState({
      updateBtn: true,
    });
  }

  // closeUpdateForm

  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
    this.getData();
  }

 

  componentDidMount() {
    this.getData();
  }


// geting candidate all career objectives detail
  getData() {
    axios
      .get(`${API_CANDIDATE}/v1/api/can-expectation`, {
        withCredentials: true,
      })
      .then((res) => {
        console.log(res);
        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
//  date validation
  isDateFormat(data) {
    let date = new Date(data);

    let year = date.getFullYear();
    let day = date.getDate();
    let month = date.getMonth() ;

    if (`${day}`.length === 1) day = `0${day}`;
    if (`${month}`.length === 1) month = `0${month}`;
    if (DATE_FORMAT === "DD-MM-YYYY") return `${day}-${month}-${year}`;

    return `${month}-${day}-${year}`;

   
  }



  render() {
    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
        {!addBtn && !updateBtn ? (
          <>
            <div
              style={{
                height: "40px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "60%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <h5 className="carrer-res" style={{ fontWeight: 500,fontSize:"1.25rem" }}> Career Objectives</h5>
              </div>

              <div style={{ width: "40%" }}>
                <i
                  style={{
                    marginRight: "80px",
                    marginTop: "5px",
                    color: "green",
                  }}
                  className="material-icons pointer contact-edit-btn"
                  onClick={this.openUpdateForm}
                >
                  edit
                </i>
              </div>
            </div>

            <ul>
              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Career Objectives
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].careerObjective : null}
                  </div>
                </div>
              </li>
              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Preferred Domain
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].preferredDomain : null}
                  </div>
                </div>
              </li>

              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Preferred Work Location
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].preferredWorkLoction : null}
                  </div>
                </div>
              </li>

              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Current CTC (INR)
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].currentCtc : null}
                  </div>
                </div>
              </li>

              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Expected CTC (INR)
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].exepectedCtc : null}
                  </div>
                </div>
              </li>
              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Notice Period (Days)
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].noticePeriod : null}
                  </div>
                </div>
              </li>
              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Serving Notice
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].servingNotice : null}
                  </div>
                </div>
              </li>

              {data.length
                ? data[0].servingNotice === "Yes" && (
                    <li>
                      <div className="details-flex-main-div">
                        <div className="contact-details-flex-div-one">
                          Last Working Day
                        </div>
                        <div className="details-flex-div-two">:</div>
                        <div className="details-flex-div-three">
                          { data[0].lastWorkingDay
                            ? DateFns.format(
                                data[0].lastWorkingDay,
                                "DD-MM-YYYY"
                              )
                            : ""}
                        </div>
                      </div>
                    </li>
                  )
                : ""}
              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">Notes</div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].notes : null}
                  </div>
                </div>
              </li>
            </ul>
          </>
        ) : null}
        {updateBtn && (
          <UpdateCareerObjective back={this.closeUpdateForm} data={data} />
        )}
      </>
    );
  }
}

export default CareerObjective;
